/* Da Luca V3.47 — One-of-a-kind add-on selection and total sync. */
(function () {
  'use strict';

  if (window.DaLucaOOAKAddonsV347) return;
  window.DaLucaOOAKAddonsV347 = true;

  function root() {
    return document.querySelector('.daluca-pdp--ooak');
  }

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    var code = currency || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount) + ' ' + code;
    } catch (e) {
      return '$' + amount.toFixed(2) + (code ? ' ' + code : '');
    }
  }

  function shopRoot() {
    var v = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    return String(v || '/').replace(/\/?$/, '/');
  }

  function url(path) {
    return shopRoot() + String(path || '').replace(/^\//, '');
  }

  async function readJson(response, fallback) {
    var data = null;
    try { data = await response.json(); } catch (e) {}
    if (!response.ok || (data && data.status && Number(data.status) >= 400)) {
      throw new Error((data && (data.description || data.message)) || fallback || 'Unable to update cart.');
    }
    return data;
  }

  async function getCart() {
    return readJson(await fetch(url('cart.js'), {
      method: 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }), 'Unable to read cart.');
  }

  function ownerKey(r) {
    return String((r && r.dataset.handle) || window.location.pathname || 'one-of-a-kind');
  }

  function matchingItem(cart, variantId, r) {
    var owner = ownerKey(r);
    return (cart && cart.items || []).find(function (item) {
      if (String(item.variant_id || item.id) !== String(variantId)) return false;
      var props = item.properties || {};
      return String(props['_DaLuca OOAK add-on for'] || '') === owner;
    }) || null;
  }

  async function addAddon(variantId, r) {
    return readJson(await fetch(url('cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{
        id: Number(variantId), quantity: 1,
        properties: { '_DaLuca OOAK add-on for': ownerKey(r) }
      }] })
    }), 'Unable to add this option.');
  }

  async function removeAddon(item) {
    if (!item) return;
    return readJson(await fetch(url('cart/change.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: item.key || item.id, quantity: 0 })
    }), 'Unable to remove this option.');
  }

  function buttons(r) {
    return Array.from(r.querySelectorAll('.daluca-pdp-upsell__add[data-product-id]'));
  }

  function setButton(button, selected, busy) {
    var label = button.querySelector('.daluca-pdp-upsell__add-label') || button;
    button.classList.toggle('is-selected', !!selected);
    button.classList.toggle('is-busy', !!busy);
    button.disabled = !!busy;
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    window.DaLucaI18n.setText(label, busy ? (selected ? 'Removing…' : 'Adding…') : (selected ? 'Remove −' : 'Add +'));
  }

  function selectedCents(r) {
    return buttons(r).reduce(function (sum, button) {
      if (!button.classList.contains('is-selected')) return sum;
      return sum + Number(button.dataset.dalucaUpsellPriceCents || 0);
    }, 0);
  }

  function updateTotal(r) {
    var total = r.querySelector('[data-daluca-total-base]');
    if (!total) return;
    var base = Number(r.dataset.dalucaBasePriceCents || 0);
    var upgrade = r.querySelector('[data-daluca-quick-release]');
    var upgradeToggle = upgrade ? upgrade.querySelector('[data-daluca-quick-release-toggle]') : null;
    var upgradeCents = upgrade && upgradeToggle && upgradeToggle.checked ? Number(upgrade.dataset.upgradePrice || 0) : 0;
    var cents = base + selectedCents(r) + upgradeCents;
    total.hidden = false;
    window.DaLucaI18n.setText(total, money(cents, r.dataset.dalucaCurrencyCode || 'USD'));
    var upgraded = r.querySelector('[data-daluca-total-upgraded]');
    if (upgraded) upgraded.hidden = true;
  }

  async function sync(r) {
    if (!r) return;
    try {
      var cart = await getCart();
      buttons(r).forEach(function (button) {
        var item = matchingItem(cart, button.dataset.productId, r);
        setButton(button, !!item, false);
      });
      updateTotal(r);
    } catch (e) {
      updateTotal(r);
    }
  }

  function install() {
    var r = root();
    if (!r || r.dataset.dalucaOoAKAddonsReady === 'true') return;
    r.dataset.dalucaOoAKAddonsReady = 'true';

    document.addEventListener('click', async function (event) {
      var button = event.target.closest('.daluca-pdp--ooak .daluca-pdp-upsell__add[data-product-id]');
      if (!button || !r.contains(button)) return;

      /* Capture the click before Habitat's generic quick-add handler so this
         button is a real add/remove toggle rather than add-only. */
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      if (button.disabled) return;

      var variantId = button.dataset.productId;
      var wasSelected = button.classList.contains('is-selected');
      setButton(button, wasSelected, true);

      try {
        var cart = await getCart();
        var item = matchingItem(cart, variantId, r);
        if (item) await removeAddon(item);
        else await addAddon(variantId, r);

        var refreshed = await getCart();
        var nowItem = matchingItem(refreshed, variantId, r);
        setButton(button, !!nowItem, false);
        updateTotal(r);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (error) {
        setButton(button, wasSelected, false);
        updateTotal(r);
      }
    }, true);

    r.addEventListener('daluca:upgrade-change', function () { updateTotal(r); });

    sync(r);
    window.setTimeout(function () { sync(r); }, 500);
    window.setTimeout(function () { sync(r); }, 1600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();

